import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "./FilePreview.scss";
import { clipText, downloadFileFromURL } from "../../utils/services/other";
import History from "../../utils/services/GlobalNavigation/navigationHistory";
import { baseUrl } from "../../utils/config/urls";
import { decryptEncryptedFile } from "../../utils/services/lighthouse";
import { isLogin } from "../../utils/services/auth";
import Dialog from '@mui/material/Dialog';
import { Metadata } from "../../components";
import ReactLoading from "react-loading";
import { BiDownload } from "react-icons/bi";
import { IoArrowBackOutline } from "react-icons/io5";
import { MdErrorOutline } from "react-icons/md";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { useSelector } from "react-redux";
import { LoginDialog } from "../../dialogs";
import { useChain } from "@cosmos-kit/react";


const getInfo = async (id: string) => {
  const info = await axios.get(`${baseUrl}/api/lighthouse/file_info?cid=${id}`);
  return info.data;
};

const findIndex = (fileArr: any[], cid: string) => {
  return fileArr.findIndex((file) => file.cid === cid);
};

function FilePreview() {
  const { id } = useParams();
  const [openLoginDialog, setLoginDialog] = useState(false);
  const [fileType, setFileType] = useState<string | undefined>(undefined);
  const [fileInfo, setFileInfo] = useState<any>(undefined);
  const [fileURL, setFileURL] = useState<string | undefined>(undefined);
  const [fileIndex, setFileIndex] = useState<number>(0);
  const [isUnSupportedType, setIsUnSupportedType] = useState(false);
  const fileStore = useSelector((store: any) => store?.file);
  const cosmoskitDialog = useChain("cosmoshub");

  const [deniedAccess, setDeniedAccess] = useState(false);

  useEffect(() => {
    let componentMounted = true;
    if (componentMounted) {
    setFileURL(undefined);
      setIsUnSupportedType(false);
      (async () => {
        const info = await getInfo(id || "");
        if (info?.mimeType) {
          info?.cid ? setFileInfo(info) : History.navigate("/dashboard");
          const fileIndex = findIndex(fileStore?.filesArr || [], id || "");

          setFileIndex(fileIndex);
          let fileType = info?.fileName.split(".").pop();
          fileType = fileType?.toLowerCase();
          setFileType(fileType);
          if (info?.encryption === "true" || info?.encryption) {
            // if file is encrypted then checking if user is logged in or not, if logged in then call decrypt function - else open login dialog

            if(isLogin()){
              const fileURL = await getDecryptedFileURL(info?.cid || "");
              setFileURL(fileURL || "");
            }else{
              setLoginDialog(true);
            }
         
          } else {
            setFileURL(`https://gateway.lighthouse.storage/ipfs/${id}`);
          }
        } else {
          window.open(
            `https://gateway.lighthouse.storage/ipfs/${id}`,
            "_blank"
          );
          History.navigate("/dashboard");
        }
      })();
    }
    return () => {
      componentMounted = false;
    };
  }, [id]);

  const getDecryptedFileURL = async (cid: string) => {
    if (
      isLogin({
        from: "viewFile",
        to: `viewFile/${id}`,
      })
    ) {
      try {
        const blob = await decryptEncryptedFile(cid);
        if (blob) {
          const url = URL.createObjectURL(blob);
          return url;
        } else {
          return null;
        }
      } catch (error) {
        setDeniedAccess(true);
      }
    }
  };

  return (
 
    <div className="filePreviewContainer">
      <div className="prevButton">
      <span
          className={fileIndex === 0 ? "disabled" : ""}
          onClick={() => {
            fileIndex !== 0 &&
              History.navigate(
                `viewFile/${fileStore?.filesArr[fileIndex - 1]?.["cid"]}`
              );
          }}
        >
          <FaAngleLeft />
        </span>
      </div>

      <div className="nextButton">
      <span
          className={fileIndex === fileStore?.totalFiles ? "disabled" : ""}
          onClick={() => {
            fileIndex !== fileStore?.totalFiles &&
              History.navigate(
                `viewFile/${fileStore?.filesArr[fileIndex + 1]?.["cid"]}`
              );
          }}
        >
          <FaAngleRight />
        </span>

      </div>
       
     
     
      <Metadata />
      {fileURL ? (
        <>
          <div className="header">
            <div className="logoContainer">
              <span
                className="ptr"
                onClick={() => {
                  History.navigate("/dashboard");
                }}
              >
                <IoArrowBackOutline />
              </span>
              &nbsp; |
              <img src="/icons/logo.png" alt="lighthouselogo" />
              <p>Lighthouse</p>
            </div>
            <div className="iconsContainer">
              {fileInfo?.fileName} &nbsp; | &nbsp;{" "}
              <span
                className="ptr fillBtn__blue"
                onClick={() => {
                  downloadFileFromURL(fileURL, fileInfo?.fileName);
                }}
              >
                {" "}
                Download &nbsp;
                <BiDownload />
              </span>
            </div>
            <div className="iconContainer__mobile">
              <span
                className="ptr fillBtn__blue"
                onClick={() => {
                  downloadFileFromURL(fileURL, fileInfo?.fileName);
                }}
              >
                <BiDownload />
              </span>
            </div>
          </div>
          <div className="subHeader__mobile">
            <p>{clipText(fileInfo?.fileName, 30, 10)}</p>
          </div>
          <div className="body">
            {isUnSupportedType ? (
              <div className="unsupportedContainer">
                <MdErrorOutline />
                <p>
                  File Type Not Supported
                  <br />
                  <span>Download File</span>
                </p>
              </div>
            ) : (
              <>
              <div className="viewer">
              {fileType === "jpeg" || fileType === "jpg" || fileType === "png" ? (
                <div className="imageviewer-container">
                  <img className="imageviewer" src={fileURL} alt="Preview" />
                </div>
              ) : (
                <>
                {/* {setIsUnSupportedType(true)} */}
                <p style={{width:'100%', textAlign:'center'}}>Un-supported File - Download the file using download button</p>
                </>
              )}
              
              </div>
              </>
            )}
          </div>
        </>
      ) : (

        <div className="filePreviewContainer__notAccess">
          <p>
            {deniedAccess ? (
              "You Dont Have Access to view / download the file"
            ) : (
              <div className="loadingContainer">
                <ReactLoading
                  type={"bubbles"}
                  color={"#4452FE"}
                  height={667}
                  width={375}
                />
              </div>
            )}
          </p>
        </div>
      )}
      <Dialog
        open={openLoginDialog}
        onClose={() => {
          setLoginDialog(false);
        }}
      >
        <LoginDialog
          setLoginDialog={setLoginDialog}
          loginRediect={`/viewFile/${id}`}
          cosmoskitDialog={cosmoskitDialog}

        />
      </Dialog>
    </div>
  );
}

export default FilePreview;
